// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"7a874082","1700":"7a874082","2799":"5046af40","3715":"7a874082","6533":"45a68a64","6728":"7a874082","8245":"7a874082"}[chunkId] + ".chunk.css";
};